module.exports = __webpack_public_path__ + "./images/e549bf87aa56e78c59035c5b529998ea.webp";